





















import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import IntegrationDetailsCard from '@/pages/integration/ServiceTitanWebHook/IntegrationDetailsCard.vue'
import RateLimitSelect from '@/pages/integration/UpdateAppSettings/RateLimitSelect.vue'
import requests from '@/helpers/requests'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number|null;
    appSettings: AppSetting[];
}


interface AppSetting {
    app: string;
    appName: string;
    enable: boolean;
    rateLimit: number;
}


interface LoadResponse {
    data: {
        appSettings: AppSetting[];
    };
    message: string;
}


@Component({
    components: {
        RateLimitSelect,
        AccountIdInput,
        IntegrationDetailsCard,
        TechTaskCard
    }
})
export default class UpdateAppSettings extends Vue {
    locationValid = false
    appSettings: null|AppSetting[] = null
    loadingInformation = false
    loadInformationErrorMessage: string|null = null
    pulsemAccountId: number|null = null

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            appSettings: this.appSettings as AppSetting[]
        }
    }


    async onLocationChange(locationValid: boolean) {
        this.loadInformationErrorMessage = null
        if (locationValid) {
            this.loadingInformation = true
            try {
                const response = await requests.post('/support/webapp-settings-load', {
                    pulsemAccountId: this.pulsemAccountId
                }) as LoadResponse
                this.appSettings = response.data.appSettings
                this.locationValid = locationValid
            } catch(e) {
                this.loadInformationErrorMessage = e.message
                this.appSettings = null
                this.locationValid = false
            }
            this.loadingInformation = false
        } else {
            this.appSettings = null
            this.locationValid = false
            this.loadingInformation = false
        }
    }

    onSuccess() {
        // No need to do anything on this one since data needs to be displayed.
    }
}
